import { IRecordFieldsList, IRecordHeaders } from 'ui-component/records/types';
import { LayoutPositionEnum } from './types';
import { getAditionalFieldsValues } from 'ui-component/RecordView/PropertiesPanel/utils';

/**
 * Returns the correct height for given module and state
 *
 * @param module {Omit<LayoutPositionEnum, 'SPLIT_VIEW'>} module to add style
 * @param currentState {LayoutPositionEnum} current state of layout
 */
export const getLayoutPositionHeight = (
    module: Omit<LayoutPositionEnum, 'SPLIT_COMMENTS' | 'SPLIT_LINE_ITEMS'>,
    currentState: LayoutPositionEnum
) => {
    switch (currentState) {
        case 'ONLY_COMMENTS':
            return module === 'ONLY_COMMENTS' ? '100%' : 0;
        case 'ONLY_DATA':
            return module === 'ONLY_DATA' ? '100%' : 0;
        case 'ONLY_LINE_ITEMS':
            return module === 'ONLY_LINE_ITEMS' ? '100%' : 0;
        case 'ONLY_ATTACHMENTS':
            return module === 'ONLY_ATTACHMENTS' ? '100%' : 0;
        case 'SPLIT_COMMENTS':
            return module === 'ONLY_LINE_ITEMS' || module === 'ONLY_ATTACHMENTS' ? 0 : '50%';
        case 'SPLIT_LINE_ITEMS':
            return module === 'ONLY_COMMENTS' || module === 'ONLY_ATTACHMENTS' ? 0 : '50%';
        case 'SPLIT_ATTACHMENTS':
            return module === 'ONLY_COMMENTS' || module === 'ONLY_LINE_ITEMS' ? 0 : '50%';

        default:
            return '50%';
    }
};

/**
 * Returns the initial value of the form depending on the data
 *
 * @param recordData
 * @param baseFieldHeaders
 * @param additionalFieldHeaders
 * @returns
 */
export const generateInitialValues = (
    recordData: IRecordHeaders,
    baseFieldHeaders: Partial<IRecordFieldsList>,
    additionalFieldHeaders: Partial<IRecordFieldsList>
): Record<string, any> => {
    const baseFields = Object.keys(baseFieldHeaders)
        .sort()
        .reduce((acc, key) => {
            const value = ['string', 'number', 'boolean', 'date'].includes(baseFieldHeaders[key]?.dataType || '')
                ? recordData[key as keyof IRecordHeaders]
                : (recordData[key as keyof IRecordHeaders] as Record<string, any>)?.id;
            return { ...acc, [key]: value };
        }, {});

    const aditionalFields =
        additionalFieldHeaders && recordData?.additionalFields
            ? getAditionalFieldsValues(additionalFieldHeaders, recordData?.additionalFields)
            : {};

    return {
        ...baseFields,
        ...aditionalFields
    };
};
